import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DirectivesModule } from '../../directives/directives.module';
import { MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatButtonModule, MatIconModule } from '@angular/material';
import { ReportDispensingPage } from './report-dispensing';

@NgModule({
  declarations: [
    ReportDispensingPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportDispensingPage),
    MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatButtonModule, MatIconModule,
    DirectivesModule
  ],
})
export class ReportDispensingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-dispensing/report-dispensing.module.ts